import React from 'react';
import LongText from '../Elements/LongText';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import moneyHelper from '../Helpers/moneyHelper';
import RedirectLinkComponent from '../Elements/RedirectLinkComponent';

export default class ClientInvoiceAssignmentItem {
  constructor(item) {
    if (item === undefined) {
      this.AsId = '';
      this.AsCfname = '';
      this.AsCfid = '';
      this.CuName = '';
      this.AsSassieAsgnId = '';
      this.CuLevel2Name = '';
      this.CuLevel3Name = '';
      this.CuLevel4Name = '';
      this.CuLevel5Name = '';
      this.AsWaveName = '';
      this.CuGroupName = '';
      this.AsAdHocGroup = '';
      this.AsSurveyName = '';
      this.CuCountry = '';
      this.InFee = '';
      this.InFeeAddit = '';
      this.InReimbursement = '';
      this.InTravel = '';
      this.InGaming = '';
      this.InMisc = '';
      this.AsLdvname = '';
      this.InFieldworkFee = '';
      this.AsEvname = '';
      this.LgsDesc = '';
      this.AsEvaluatorCompletedDate = '';
      this.InRcysymbol = '';
      this.InRcycode = '';
      this.PricingCurrencyCode = '';
      this.IeRcycode = '';
    } else {
      this.AsId = item.asId;
      this.AsCfname = item.asCfname;
      this.AsCfid = item.asCfid;
      this.CuName = item.cuName;
      this.AsSassieAsgnId = item.asSassieAsgnId;
      this.CuLevel2Name = item.cuLevel2Name;
      this.CuLevel3Name = item.cuLevel3Name;
      this.CuLevel4Name = item.cuLevel4Name;
      this.CuLevel5Name = item.cuLevel5Name;
      this.AsWaveName = item.asWaveName;
      this.CuGroupName = item.cuGroupName;
      this.AsAdHocGroup = item.asAdHocGroup;
      this.AsSurveyName = item.asSurveyName;
      this.CuCountry = item.cuCountry;
      this.InFee = item.inFee;
      this.InFeeAddit = item.inFeeAddit;
      this.InReimbursement = item.inReimbursement;
      this.InTravel = item.inTravel;
      this.InGaming = item.inGaming;
      this.InMisc = item.inMisc;
      this.AsLdvname = item.asLdvname;
      this.InFieldworkFee = item.inFieldworkFee;
      this.AsEvname = item.asEvname;
      this.LgsDesc = item.lgsDesc;
      this.AsEvaluatorCompletedDate = item.asEvaluatorCompletedDate;
      this.InRcysymbol = item.inRcysymbol;
      this.InRcycode = item.inRcycode;
      this.PricingCurrencyCode = item.pricingCurrencyCode;
      this.IeRcycode = item.ieRcycode;
    }
    this.Selected = false;
  }

  static MoneyFields = ['InFee', 'InFeeAddit', 'InReimbursement', 'InTravel', 'InGaming', 'InMisc'];
  static DateFields = ['AsEvaluatorCompletedDate'];

  static Currency() {
    return 'InRcycode';
  }

  static FieldsToShowInDataTable() {
    return [
      {
        label: ClientInvoiceAssignmentItem.getSelectedCellHeader,
        orderById: '',
        data: ClientInvoiceAssignmentItem.getSelectedCellContent,
        type: FieldTypesEnum.PureDataField,
        minWidth: 10,
      },
      {
        label: 'Project',
        orderById: 'AsCfname',
        data: ClientInvoiceAssignmentItem.getProjectCellContent,
        minWidth: 40,
      },
      { label: 'Project ID', orderById: 'AsCfid', data: 'AsCfid', minWidth: 20 },
      { label: 'Survey', orderById: 'AsSurveyName', data: 'AsSurveyName', minWidth: 40 },
      {
        label: 'Location',
        orderById: 'CuName',
        data: ClientInvoiceAssignmentItem.getLocationCellContent,
        minWidth: 40,
      },
      { label: 'Apollo ID', orderById: 'AsSassieAsgnId', data: ClientInvoiceAssignmentItem.idFunction, minWidth: 20 },
      {
        label: 'Level 2',
        orderById: 'CuLevel2Name',
        data: ClientInvoiceAssignmentItem.getLevel2CellContent,
        minWidth: 10,
      },
      {
        label: 'Level 3',
        orderById: 'CuLevel3Name',
        data: ClientInvoiceAssignmentItem.getLevel3CellContent,
        minWidth: 10,
      },
      {
        label: 'Level 4',
        orderById: 'CuLevel4Name',
        data: ClientInvoiceAssignmentItem.getLevel4CellContent,
        minWidth: 10,
      },
      {
        label: 'Level 5',
        orderById: 'CuLevel5Name',
        data: ClientInvoiceAssignmentItem.getLevel5CellContent,
        minWidth: 10,
      },
      { label: 'Wave', orderById: 'AsWaveName', data: ClientInvoiceAssignmentItem.getWaveCellContent, minWidth: 30 },
      { label: 'Group', orderById: 'CuGroupName', data: ClientInvoiceAssignmentItem.getGroupCellContent, minWidth: 10 },
      {
        label: 'Ad-Hoc',
        orderById: 'AsAdHocGroup',
        data: ClientInvoiceAssignmentItem.getAdHocCellContent,
        minWidth: 10,
      },
      { label: 'Country', orderById: 'CuCountry', data: 'CuCountry', minWidth: 10 },
      { label: 'ClientFee', orderById: 'InFee', data: 'InFee', minWidth: 10 },
      { label: 'Addit. Fee', orderById: 'InFeeAddit', data: 'InFeeAddit', minWidth: 10 },
      { label: 'Reimb', orderById: 'InReimbursement', data: 'InReimbursement', minWidth: 10 },
      { label: 'Travel', orderById: 'InTravel', data: 'InTravel', minWidth: 10 },
      { label: 'Gaming', orderById: 'InGaming', data: 'InGaming', minWidth: 10 },
      { label: 'Misc', orderById: 'InMisc', data: 'InMisc', minWidth: 10 },
      {
        label: 'FW Office',
        orderById: 'AsLdvname',
        data: ClientInvoiceAssignmentItem.getFieldworkOfficeCellContent,
        minWidth: 30,
      },
      {
        label: 'FW Fee',
        orderById: 'InFieldworkFee',
        data: (item) => moneyHelper.toMoneyFormat(item.InFieldworkFee, item.PricingCurrencyCode),
        minWidth: 10,
      },
      {
        label: 'Evaluator',
        orderById: 'AsEvname',
        data: ClientInvoiceAssignmentItem.getEvaluatorCellContent,
        minWidth: 40,
      },
      { label: 'Status', orderById: 'LgsDesc', data: 'LgsDesc', minWidth: 20 },
      { label: 'Completed On', orderById: 'AsEvaluatorCompletedDate', data: 'AsEvaluatorCompletedDate', minWidth: 30 },
    ];
  }

  static idFunction(item) {
    return (
      <RedirectLinkComponent
        isFigmaStyle={true}
        path='assignments'
        tooltipText={item.AsSassieAsgnId}
        text={item.AsSassieAsgnId}
        keyValuePairs={[
          { key: 'AsBillClient', value: '' },
          { key: 'AsPayEvaluator', value: '' },
          { key: 'AsSassieAsgnId', value: item.AsSassieAsgnId },
        ]}
      />
    );
  }

  static getProjectCellContent(item) {
    return (
      <LongText
        text={item.AsCfname ? item.AsCfname : ' '}
        maxLength={15}
      />
    );
  }

  static getLocationCellContent(item) {
    return (
      <LongText
        text={item.CuName ? item.CuName : ' '}
        maxLength={15}
      />
    );
  }

  static getWaveCellContent(item) {
    return (
      <LongText
        text={item.AsWaveName ? item.AsWaveName : ' '}
        maxLength={8}
      />
    );
  }

  static getGroupCellContent(item) {
    return (
      <LongText
        text={item.CuGroupName ? item.CuGroupName : ' '}
        maxLength={8}
      />
    );
  }

  static getLevel2CellContent(item) {
    return (
      <LongText
        text={item.CuLevel2Name ? item.CuLevel2Name : ' '}
        maxLength={8}
      />
    );
  }

  static getLevel3CellContent(item) {
    return (
      <LongText
        text={item.CuLevel3Name ? item.CuLevel3Name : ' '}
        maxLength={8}
      />
    );
  }

  static getLevel4CellContent(item) {
    return (
      <LongText
        text={item.CuLevel4Name ? item.CuLevel4Name : ' '}
        maxLength={8}
      />
    );
  }

  static getLevel5CellContent(item) {
    return (
      <LongText
        text={item.CuLevel5Name ? item.CuLevel5Name : ' '}
        maxLength={8}
      />
    );
  }

  static getAdHocCellContent(item) {
    return (
      <LongText
        text={item.AsAdHocGroup ? item.AsAdHocGroup : ' '}
        maxLength={10}
      />
    );
  }

  static getEvaluatorCellContent(item) {
    return (
      <LongText
        text={item.AsEvname ? item.AsEvname : ' '}
        maxLength={10}
      />
    );
  }

  static getFieldworkOfficeCellContent(item) {
    return (
      <LongText
        text={item.AsLdvname ? item.AsLdvname : ' '}
        maxLength={10}
      />
    );
  }

  static getSelectedCellHeader(item) {
    return (
      <div>
        <input
          type='checkbox'
          checked={ClientInvoiceAssignmentItem.selectedStatus()}
          onChange={(e) => {
            ClientInvoiceAssignmentItem.clickOnGlobalSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static getSelectedCellContent(item) {
    return (
      <div className='text-center'>
        <input
          type='checkbox'
          checked={item.Selected}
          onChange={(e) => {
            ClientInvoiceAssignmentItem.clickOnSelect(item, e.target.checked);
          }}
        />
      </div>
    );
  }

  static clickOnGlobalSelect(item, selected) {}

  static clickOnSelect(item, selected) {}

  static selectedStatus() {
    return false;
  }
}
